import { Link, useLocation, useNavigate } from "react-router";
import { useState, useEffect } from "react"; // Add useState and useEffect
import { isSinglePageActive } from "../../../../utils/daynamicNavigation";
import Loader from "../../loader/Loader";
import { useUnsavedChanges } from "../../../user/components/UnsavedChangesProvider";

import { useSelector } from "react-redux";
import { trackButtonClick } from "@/utils/analytics";

const tabItems = [
  {
    id: 1,
    name: "My Profile",
    route: "/my-shopper/myProfile",
    icon: "flaticon-user",
  },
  {
    id: 2,
    name: "My Upcoming Auctions",
    route: "/my-shopper/watchComProperties",
    icon: "flaticon-box",
  },
  {
    id: 3,
    name: "My Bids",
    route: "/my-shopper/myBids",
    icon: "flaticon-box",
  },
  {
    id: 4,
    name: "My Purchase Profile",
    route: "/my-shopper/purchaseProfile",
    icon: "flaticon-box",
  },
  {
    id: 6,
    name: "My Offers",
    route: "/my-shopper/myOffers",
    icon: "flaticon-box",
  },
  {
    id: 7,
    name: "Saved Searches",
    route: "/my-shopper/savedSearches",
    icon: "flaticon-box",
  },
  {
    id: 8,
    name: "Favorites",
    route: "/my-shopper/watchProperties",
    icon: "flaticon-box",
  },
  {
    id: 9,
    name: "Account Settings",
    route: "/my-shopper/accountSettings",
    icon: "flaticon-user",
  },
];

const SidebarMenu = ({
  hasUnsavedChanges,
  setNextRoute,
  setShowConfirmModal,
}) => {
  const { pathname } = useLocation();
  const user = useSelector((state) => state.user);

  const [pageLoading, setPageLoading] = useState(false);
  const [accountTab, setAccountTab] = useState(tabItems);
  const navigate = useNavigate();

  // Add effect to handle route changes
  useEffect(() => {
    setPageLoading(true);
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 500); // Adjust timing as needed

    return () => clearTimeout(timer);
  }, [pathname]); // Trigger on pathname change

  useEffect(() => {
    if (!user) return;

    let updatedTabs = [...tabItems];

    if (user?.user?.userStatus === "PROFILE") {
      // remove purhcase profile
      updatedTabs = updatedTabs.filter((item) => item.id !== 4);
    }
    if (user?.user?.isCfdBuyer) {
      // Add CFD as second-to-last item (before Account Settings)
      updatedTabs.splice(updatedTabs.length - 3, 0, {
        id: 5,
        name: "Cash For Deed",
        route: "/my-shopper/cash-for-deed",
        icon: "flaticon-box",
      });
    }

    setAccountTab(updatedTabs);
  }, [user]);

  const handleNavigation = (path) => {
    if (hasUnsavedChanges) {
      setNextRoute(path);
      setShowConfirmModal(true);
    } else {
      navigate(path);
    }
  };
  return (
    <>
      <ul className={`sidebar-menu ${pageLoading ? "opacity-1" : ""}`}>
        {/* <li className="title">
          <ul>
            <li
              className={`treeview ${
                isSinglePageActive("/user-dashboard", pathname) ? "active" : ""
              }`}
            >
              <Link to="/user-dashboard">
                <i className="flaticon-layers"></i>
                <span> Dashboard</span>
              </Link>
            </li>
          </ul>
        </li> */}

        <li className="title">
          {/* <span>Manage Account</span> */}
          <ul>
            {accountTab.map((item) => (
              <li
                className={
                  isSinglePageActive(item.route, pathname) ? "active" : ""
                }
                key={item.id}
              >
                <a
                  href={item.route}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(item.route);
                    trackButtonClick({
                      eventName: "shopper_left_nav_click",
                      eventCategory: "Shopper-left-navigation",
                      eventSource: "Shopper left navigation click",
                      eventParams: { nav_item: item.name },
                    });
                  }}
                >
                  <span>{item.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </li>

        {/* <li className="title">
          <span>Manage Listings</span>
          <ul>
            {manageListing.map((item) => (
              <li
                className={
                  isSinglePageActive(item.route, pathname) ? "active" : ""
                }
                key={item.id}
              >
                <Link to={item.route}>
                  <i className={item.icon}></i> <span>{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </li> */}
      </ul>
    </>
  );
};

export default SidebarMenu;
